// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArrivalModal_overlay__XZtLo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.ArrivalModal_modal__gwJpN {
  background: white;
  padding: 24px;
  border-radius: 8px;
  width: 545px;
  max-width: 90%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.ArrivalModal_header__ldtP5 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ArrivalModal_header__ldtP5 h2 {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
}

.ArrivalModal_close__ycj3P {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
}

.ArrivalModal_body__C8GLN {
  margin-top: 20px;
  background: rgba(249, 249, 249, 1);
  border-radius: 8px;
  padding: 12px;
}

.ArrivalModal_label__f\\+nV- {
    font-size: 18px;
    text-align: left;
    font-weight: 600;
    margin-bottom: 16px;
}

.ArrivalModal_list__kmIDX {
  list-style: none;
  padding: 0;
  margin: 0;
}

.ArrivalModal_item__ZbqwZ {
  margin-bottom: 18px;
}

.ArrivalModal_radioLabel__b2doR {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.ArrivalModal_radioLabel__b2doR input {
  display: none;
}

.ArrivalModal_customRadio__qU9GR {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(29, 135, 82, 1);
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
}

.ArrivalModal_radioLabel__b2doR input:checked + .ArrivalModal_customRadio__qU9GR::after {
    content: '';
    width: 10px;
    height: 10px;
    background: rgba(29, 135, 82, 1);
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
}

.ArrivalModal_footer__-Q2J5 {
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
}

.ArrivalModal_cancel__-b43R {
  padding: 9px 20px;
  background: none;
  color: rgba(115, 115, 115, 1);
  border: 1px solid rgba(115, 115, 115, 1);
  border-radius: 4px;
  cursor: pointer;
}

.ArrivalModal_select__8LFqS {
  padding: 9px 20px;
  background: rgba(29, 135, 82, 1);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/styles/ArrivalModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  padding: 24px;\n  border-radius: 8px;\n  width: 545px;\n  max-width: 90%;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header h2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.close {\n  background: none;\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n}\n\n.body {\n  margin-top: 20px;\n  background: rgba(249, 249, 249, 1);\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.label {\n    font-size: 18px;\n    text-align: left;\n    font-weight: 600;\n    margin-bottom: 16px;\n}\n\n.list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.item {\n  margin-bottom: 18px;\n}\n\n.radioLabel {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.radioLabel input {\n  display: none;\n}\n\n.customRadio {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(29, 135, 82, 1);\n  border-radius: 50%;\n  margin-right: 10px;\n  position: relative;\n}\n\n.radioLabel input:checked + .customRadio::after {\n    content: '';\n    width: 10px;\n    height: 10px;\n    background: rgba(29, 135, 82, 1);\n    border-radius: 50%;\n    position: absolute;\n    top: 3px;\n    left: 3px;\n}\n\n.footer {\n  margin-top: 25px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.cancel {\n  padding: 9px 20px;\n  background: none;\n  color: rgba(115, 115, 115, 1);\n  border: 1px solid rgba(115, 115, 115, 1);\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.select {\n  padding: 9px 20px;\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `ArrivalModal_overlay__XZtLo`,
	"modal": `ArrivalModal_modal__gwJpN`,
	"header": `ArrivalModal_header__ldtP5`,
	"close": `ArrivalModal_close__ycj3P`,
	"body": `ArrivalModal_body__C8GLN`,
	"label": `ArrivalModal_label__f+nV-`,
	"list": `ArrivalModal_list__kmIDX`,
	"item": `ArrivalModal_item__ZbqwZ`,
	"radioLabel": `ArrivalModal_radioLabel__b2doR`,
	"customRadio": `ArrivalModal_customRadio__qU9GR`,
	"footer": `ArrivalModal_footer__-Q2J5`,
	"cancel": `ArrivalModal_cancel__-b43R`,
	"select": `ArrivalModal_select__8LFqS`
};
export default ___CSS_LOADER_EXPORT___;
